import script from "./CommentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsList.vue?vue&type=script&setup=true&lang=js"

import "./CommentsList.vue?vue&type=style&index=0&id=3facd349&lang=less"

const __exports__ = script;

export default __exports__